<template>
  <div>
    <div class="box">
      <div class="topictitle">{{ questionObject.name }}</div>
      <div class="topic__type-des">{{ questionObject.description }}</div>
      <div class="titPrompt"><span>指导语：</span>{{questionObject.guidance}}</div>  

      <fieldset class="messagevote" v-if="titleData.length !=0">
        <div>测评时长：{{ questionObject.times ? `约 ${questionObject.times} 分钟` : ''}}</div>
        <div style="margin-top:10px">您正在做测试，已完成{{lxc.toFixed()}}%</div>
        <el-progress :percentage="lxc" :format="format" :stroke-width="5"></el-progress>
        <div id="divTitle1">
          <span>{{isIndextwo}}.</span>
          {{ titleData[isIndex].name }}
        </div>

        <ul class="ulradiocheck">
          <li
            v-for="items in titleData[isIndex].choiceList"
            :key="items.id"
            @click.stop="radiosChange(items, titleData[isIndex].id)"
          >
            <input
              type="radio"
              :name="titleData[isIndex].id"
              :id="items.id"
              :value="items.name"
              style="margin-right:10px"
            />
            {{items.name }}
            <!-- @click="radiosChange(items, titleData[isIndex].id)" -->
            <!-- <label
              @click="radiosChange(items, titleData[isIndex].id)"
              style="display: inline-block;height: 60px;width:95%"
              :for="items.id"
            >{{items.name }}</label>-->
          </li>
        </ul>
      </fieldset>
      <div style="text-align: center;">备注：当完成进度达到{{titleData.length}} / {{titleData.length}}时可自动提交</div>
      <!-- <div class="nexclas">
        <el-button @click="nextPage()">下一题</el-button>
      </div>-->
    </div>
    <!-- <div class="sumitgot">
      <el-button type="primary" style="margin-bottom:20px" @click="goto">提交</el-button>
    </div>-->
  </div>
</template>
<script>
import * as evaluation from '@/api/evaluation/index';
export default {
  props: ['topicId', 'planId'],
  data() {
    return {
      questionObject: {}, //主题的信息
      titleData: [], //题目的信息
      isIndex: 0,
      isIndextwo: 1,
      lxc: 0,
      isflg: true,
    };
  },
  created() {
    this.GetQuestionInfo();
    this.HeartTopicGet();
  },
  methods: {
    format(percentage) {
      return `${this.isIndextwo}/${this.titleData.length}题`;
    },

    // 获取标题
    HeartTopicGet() {
      let data = { id: this.topicId };
      evaluation.HeartTopicGet(data).then((res) => {
        this.questionObject = res.result;
      });
    },

    // 获取题目信息
    GetQuestionInfo() {
      let data = { topicId: this.topicId };
      evaluation.GetQuestionInfo(data).then((res) => {
        this.titleData = res.result;
      });
    },

    radiosChange(item, topicId) {
      if (this.isflg == false) {
        return false;
      }
      let obj = {};
      if (topicId != null) {
        //单选按钮
        for (let i = 0; i < this.titleData.length; i++) {
          if (this.titleData[i].id == topicId) {
            obj = this.titleData[i];
          }
        }
        //先把题目循环出来，然后将每一道题目的选项在循环出来
        if (obj != null) {
          for (let j = 0; j < obj.choiceList.length; j++) {
            obj.choiceList[j].checked = false;
          }
        }
        item.checked = true;
      } else {
        //复选按钮
        item.checked = !item.checked;
      }

      if (this.titleData.length != this.isIndextwo) {
        this.isIndex++;
        this.isIndextwo++;
        this.lxc = (this.isIndex / this.titleData.length) * 100;
      } else {
        this.isflg = false;
        this.lxc = 100;
        this.goto();
      }
    },

    goto() {
      let num = 0;
      let nums = 0;
      // 循环所有题目，如果不是问答题就++，得的值就是单选加双选的值
      for (let i = 0; i < this.titleData.length; i++) {
        nums++;
      }

      // 循环出单选和双选的数量去和nums比较
      for (let i = 0; i < this.titleData.length; i++) {
        for (let j = 0; j < this.titleData[i].choiceList.length; j++) {
          if (this.titleData[i].choiceList[j].checked == true) {
            num++;
            break;
          }
        }
      }

      if (num == nums) {
        let url =
          '/api/HeartData/AddMore?topicId=' +
          this.topicId +
          '&userId=' +
          this.$store.state.User.ids +
          '&planId=' +
          this.planId;
        //任务测评
        evaluation.AddMoreTwo(url, this.titleData).then((res) => {
          // console.log(res);
          if (res.result !== 0) {
            if (res.message) {
              this.$message({
                message: '成功！',
                type: 'success',
              });

              var temp = document.getElementsByTagName('input');
              for (let i = 0; i < temp.length; i++) {
                temp[i].checked = false;
              }
              for (let i = 0; i < this.titleData.length; i++) {
                for (let j = 0; j < this.titleData[i].choiceList.length; j++) {
                  this.titleData[i].choiceList[j].checked = false;
                }
              }

              this.$emit('goBack', this.questionObject);
              this.$emit('updateList');
            }
          } else {
            this.$message({
              message: '此问卷以提交过一次',
              type: 'warning',
            });
          }
        });
      } else {
        this.$message({
          message: '请选择完后提交！',
          type: 'error',
        });
      }
    },
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  margin: 0 auto;
  min-height: 600px;
  background-color: #ffffff;
  margin-bottom: 40px;
  padding-bottom: 20px;
}
.topictitle {
  font: 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Microsoft YaHei',
    'Microsoft YaHei UI', '微软雅黑', sans-serif;
  padding-top: 26px;
  padding: 26px 10px 15px;
  color: #1492ff;
  text-align: center;
  font-size: 22px;
  font-weight: bold;
}
.title {
  font-size: 20px;
  line-height: 32px;
  font-weight: bold;
  margin: 0;
  padding: 0;
  text-align: center;
}
.topic__type-des {
  font-size: 16px;
  margin: 20px 20px;
  margin-bottom: 10px;
  padding: 0 20px 0px 20px;
}
.titPrompt{
  margin: 0px 40px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  line-height: 20px;
  font-size: 16px;
  border-bottom: 2px dashed #f7f7f7;
}
.titPrompt>span{
  color: green;
}
.texta {
  margin-top: 15px;
  border: 1px solid #f2f2f2;
  padding: 5px 8px;
  font-size: 14px;
}

.req {
  color: red;
  font-weight: bold;
  position: absolute;
  top: 3px;
  left: -10px;
}
fieldset {
  margin: 0 80px;
  min-height: 550px;
}
.sumitgot {
  width: 100%;
  margin: 0 auto;
  text-align: right;
}
.nexclas {
  padding-right: 100px;
  text-align: right;
}
#divTitle1 {
  font-size: 16px;
  margin: 30px 0;
}
.ulradiocheck {
  background-color: #f9f9f9;
}
.ulradiocheck li {
  font-size: 14px;
  height: 60px;
  line-height: 60px;
  padding: 0 0 0 20px;
  border-bottom: 1px solid #eee;
}
.ulradiocheck li:hover {
  cursor: pointer;
  background-color: #feffdf;
}

.addRedEnd:after {
  content: '*';
  color: red;
  font-size: 18px;
}
.form {
  margin-top: 20px;
}
.disinput {
  display: flex;
}
.disinputText {
  width: 400px;
}
/deep/ .el-input__inner {
  height: 33px;
  line-height: 33px;
  padding: 0 5px;
}
/deep/ .el-progress-bar {
  margin-right: -73px;
}
/deep/.el-progress-bar__outer {
  width: 690px;
}

/deep/.messagevote .el-progress__text{
  margin-left: 20px;
}
</style>